(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-collection-header"] && !Shopify.designMode) return;
  try {
    
  (function mzOnReady(run) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run(); })(function () {

  // Deep-link the "your vehicle" bar to the vehicle page pre-filtered to this collection's axis (brand / part type / usage).
  document.querySelectorAll('.mz-chead__vbar').forEach((bar) => {
    const meta = document.querySelector('meta[name="mz:vehicle-filter"]');
    const filter = meta ? meta.getAttribute('content') : '';
    if (!filter) return;
    const link = bar.querySelector('[data-role="link"]');
    const apply = (vehicle) => {
      if (!vehicle || !link) return;
      link.href = vehicle.url + (vehicle.url.includes('?') ? '&' : '?') + filter;
    };
    document.addEventListener('mz:vehicle-changed', (e) => apply(e.detail));
    try { apply(JSON.parse(localStorage.getItem('mz_vehicle') || 'null')); } catch (e) {}
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-inquiry-form"] && !Shopify.designMode) return;
  try {
    
  (function mzOnReady(run) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run(); })(function () {

  (function () {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('.mz-inquiry').forEach((section) => {
      const map = { product: ['product', 'sku', 'variant'], vehicle: ['vehicle'], brand: ['brand'], qty: ['qty'] };
      const parts = [];
      Object.entries(map).forEach(([role, keys]) => {
        const values = keys.map((k) => params.get(k)).filter(Boolean);
        if (!values.length) return;
        const field = section.querySelector('[data-prefill="' + role + '"]');
        const value = role === 'product' ? values.join(' · ') : values[0];
        if (field && !field.value.trim() || (field && role === 'qty')) field.value = value;
        if (role !== 'qty') parts.push(value);
      });
      const saved = (() => { try { return JSON.parse(localStorage.getItem('mz_vehicle') || 'null'); } catch (e) { return null; } })();
      const vehicleField = section.querySelector('[data-prefill="vehicle"]');
      if (vehicleField && !vehicleField.value && saved && saved.name) vehicleField.value = saved.name;
      if (parts.length) {
        const summary = section.querySelector('[data-role="summary"]');
        const text = section.querySelector('[data-role="summary-text"]');
        if (summary && text) { text.textContent = (summary.dataset.prefix || 'Request for: ') + parts.join(' — '); summary.hidden = false; }
      }
      const pageField = section.querySelector('[data-prefill="page"]');
      if (pageField && document.referrer) pageField.value += ' (from ' + document.referrer + ')';
    });
  })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-vehicle-bar"] && !Shopify.designMode) return;
  try {
    
  (function mzOnReady(run) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run(); })(function () {

  document.querySelectorAll('.mz-vbar-wrap').forEach((wrap) => {
    const dialog = wrap.querySelector('dialog');
    const open = wrap.querySelector('[data-role="open"]');
    const close = wrap.querySelector('[data-role="close"]');
    if (!dialog || !open) return;
    open.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
    close && close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-vehicle-header"] && !Shopify.designMode) return;
  try {
    
  (function mzOnReady(run) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run(); })(function () {

  document.querySelectorAll('.mz-vhead__set').forEach((btn) => {
    const bar = btn.closest('.mz-vhead__setter');
    const vehicle = {
      handle: btn.dataset.handle, url: btn.dataset.url, make: btn.dataset.make, model: btn.dataset.model,
      name: btn.dataset.name, yearStart: Number(btn.dataset.ys) || null, yearEnd: Number(btn.dataset.ye) || null, vehicleClass: btn.dataset.class,
    };
    const sync = () => {
      let saved = null;
      try { saved = JSON.parse(localStorage.getItem('mz_vehicle') || 'null'); } catch (e) {}
      const mine = saved && saved.handle === vehicle.handle;
      bar && (bar.dataset.hasVehicle = mine ? 'true' : 'false');
      btn.setAttribute('aria-pressed', mine ? 'true' : 'false');
    };
    btn.addEventListener('click', () => { if (window.MZVehicle) window.MZVehicle.store.set(vehicle); else { try { localStorage.setItem('mz_vehicle', JSON.stringify(vehicle)); } catch (e) {} } sync(); });
    document.addEventListener('mz:vehicle-changed', sync);
    sync();
  });
  });

  } catch(e) { console.error(e); }
})();
})();
